import React from 'react';
import './CourseBanner.scss';

const CourseBanner = ({ 
  courseConfig, 
  onClick, 
  isOpen, 
  isDisabled = false 
}) => {
  if (!courseConfig) return null;

  return (
    <div 
      className={`${courseConfig.buttonClass} ${isDisabled ? 'disabled' : ''}`}
      onClick={isDisabled ? undefined : onClick}
    >
      {courseConfig.buttonText}
    </div>
  );
};

export default CourseBanner; 